import { Box } from "@mui/material";
import { useRouter } from "next/router";
import React, { useContext, useEffect, useState } from "react";

import { Context } from "../../context/context";
import { MemoizedLeadCaptureBenefits } from "../../modules/Lead Capture/Benefits/benefitsLeadCapture";
import { MemoizedLeadCaptureBookingForm } from "../../modules/Lead Capture/BookingForm/bookingForm";
import { MemoizedLeadCaptureMain } from "../../modules/Lead Capture/VehicleData/vehicleData";
import TopBanner from "../../SDK/Banner/topBanner";
import { sendAnalytics } from "../../utils/analyticsCommon";

const LeadCapture = ({ vehicleDataLocal }) => {
  const state = useContext(Context);
  const location = useRouter();

  const [vehicleData, setVehicleData] = useState(vehicleDataLocal[0]);
  const [vehicleDataImageSlider, setVehicleDataImageSlider] = useState(
    vehicleDataLocal[0]?.images
  );

  let type = location.pathname.split("/")[2]; //location.query;
  const routeName = location.query;
  const vehicle_type = routeName?.vehicle_type?.toLowerCase();
  let h1Text = "";

  if (vehicle_type?.includes("piaggio")) {
    type = "piaggio";
    // h1Text = "Piaggio Ape Electrik by Turno | Know more about Piaggio Ape Electrik | Piaggio Ape Electrik Service FAQ",
  } else if (vehicle_type?.includes("mahindra")) {
    type = "mahindra";
    //  h1Text = "Mahindra Treo Zor by Turno | Know more about Mahindra Treo Zor  | Mahindra Treo Zor  Service FAQ",
  } else if (vehicle_type?.includes("osm")) {
    type = "OSM";
  } else if (vehicle_type?.includes("etrio")) {
    type = "ETRIO";
    // h1Text= "Etrio Touro Max+  by Turno | Know more about Etrio Touro Max+",
  }
  // useEffect(() => {
  //   if (type) {
  //     let vehicleDataLocal = vehicles.filter(function (vehicle) {
  //       return vehicle.id === vehicleInfo[type]?.vehicleId;
  //     });
  //     setVehicleData(vehicleDataLocal[0]);
  //     setVehicleDataImageSlider(vehicleDataLocal[0]?.images);
  //   }
  // }, [type]);
  useEffect(() => {
    if (vehicleData?.name?.length > 0) {
      let payload = {
        screen_name: "vehicle booking",
        vehicle_id: vehicleData?.vehicle_id,
        vehicle_name: vehicleData?.name,
      };
      sendAnalytics("screen_viewed", payload, "en");
    }
    // eslint-disable-next-line
  }, [vehicleData]);

  return (
    <Box sx={{ pt: { xs: 0, md: 0 } }}>
      <TopBanner
        location={
          state?.selectedCity === "Others" ? "India" : state?.selectedCity
        }
        vehicleName={vehicleData?.vehicle_name + "  in"}
      />
      <MemoizedLeadCaptureMain
        vehicleData={vehicleData}
        vehicleDataImageSlider={vehicleDataImageSlider}
        type={type}
      />
      <MemoizedLeadCaptureBookingForm vehicleData={vehicleData} />
      {/* <VehicleDescription type={type} />
      {(type === "piaggio" || type === "mahindra" || type === "ETRIO") && (
        <MaintainenceFAQ type={type} />
      )} */}
      <MemoizedLeadCaptureBenefits />
      {/* <MemoizedTestimonials
        title={"Our most recent customers"}
        buttonText={"Book vehicle"}
        name={vehicleData?.testimonials?.customer_1?.name ?? ""}
        work={vehicleData?.testimonials?.customer_1?.work ?? ""}
        description={vehicleData?.testimonials?.customer_1?.description ?? ""}
        thumbnail={vehicleData?.testimonials?.customer_1?.img ?? ""}
        videoLink={vehicleData?.testimonials?.customer_1?.videoLink ?? ""}
        type={type ?? ""}
        page={"booking"}
        data={vehicleData ?? ""}
      /> */}
    </Box>
  );
};
// export default LeadCapture;
export const MemoizedLeadCapture = React.memo(LeadCapture);
